module.exports = require('./helpers/bundle-url').getBundleURL('52vsC') + "logo.c51670a8.svg";